import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";
//
import { dispatch } from "../store";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  prime: null,
};

const slice = createSlice({
  name: "prime",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET PRIME
    getPrimeSuccess(state, action) {
      state.isLoading = false;
      state.prime = action.payload;
    },

    // UPDATE PRIME
    updatePrimeSuccess(state, action) {
      state.prime = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { updatePrimeSuccess } = slice.actions;

// ----------------------------------------------------------------------

export function getPrime() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/dashboard-supervisor/prime-general`
      );
      dispatch(slice.actions.getPrimeSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export async function updatePrime(data) {
  const response = await axios.put(`/api/dashboard-supervisor/prime-general`, data);
  return response.data;
}
